module.exports = __webpack_public_path__ + "static/media/blog4_sm.f2b025ef.webp";